import { Component, Ref, Vue, Watch } from 'vue-property-decorator'

import store from '@/app/store'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import tenantsService from '@/tenants/services/tenants-service'
import UserDialog from '@/users/components/user-dialog/user-dialog'
import User from '@/users/entities/user'
import accountService from '@/users/services/account-service'
import usersService from '@/users/services/users-service'
import AuthModule from '@/users/store/auth-module'
import { getModule } from 'vuex-module-decorators'

@Component
export default class Settings extends Vue {

  @Ref()
  private dialog!: UserDialog

  private loading: boolean = false
  private users: User[] = []
  private file = new File([''], '')
  private logoUrl = '#'
  private isSmallBusiness = false
  private isSmallBusinessIsLoading = false

  private pagination = new PaginationRequest()

  public async mounted() {
    this.updateLogoUrl()

    this.isSmallBusinessIsLoading = true
    const authModule = getModule(AuthModule, store)
    const tenant = await tenantsService.findOneAsync(authModule.tenant)
    if (tenant) {
      this.isSmallBusiness = tenant.isSmallBusiness
    }
    this.isSmallBusinessIsLoading = false
  }

  public async fetchAll() {
    this.loading = true
    const response = await usersService.findAllAsync(this.pagination)
    this.users = response.items
    this.pagination.totalItems = response.totalItems
    this.loading = false
  }

  public create() {
    this.dialog.create()
  }

  public edit(user: User) {
    this.dialog.edit(user)
  }

  public async save(user: User) {
    await accountService.saveAsync(user)
    await this.fetchAll()
  }

  public async update(user: User) {
    await accountService.updateAsync(user)
    await this.fetchAll()
  }

  public async activate(user: User) {
    await accountService.activateAsync(user)
    await this.fetchAll()
  }

  public async fileSelected(file: File) {
    if (file.size > 0) {
      await tenantsService.uploadLogo(file)
      this.updateLogoUrl()
    }
  }

  public async removeLogo() {
    await tenantsService.removeLogo()
    const img = this.$refs['logoImageTag'] as HTMLImageElement
    img.style.display = 'none'
  }

  private updateLogoUrl() {
    const authModule = getModule(AuthModule, store)
    this.logoUrl = `${process.env.VUE_APP_API_URL}/tenants/logo?id=${authModule.tenant}&${new Date().getTime()}`
    const img = this.$refs['logoImageTag'] as HTMLImageElement
    img.style.display = 'block'
  }

  @Watch('pagination', { deep: true })
  private async paginationChanged(newVal: PaginationRequest, oldVal: PaginationRequest) {
    if (newVal !== oldVal) {
      await this.fetchAll()
    }
  }

  @Watch('isSmallBusiness')
  private async isSmallBusinessChanged(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal && !this.isSmallBusinessIsLoading) {
      this.isSmallBusinessIsLoading = true
      const authModule = getModule(AuthModule, store)
      await tenantsService.updateIsSmallBusiness(authModule.tenant, newVal)
      this.isSmallBusinessIsLoading = false
    }
  }
}
